import * as subjectIds from '../enums/subjects'

let flaggedSubjects = [
  'Arts Education',
  'Career Technical Education',
  'Health and PE',
  'Language Arts',
  'Social Studies',
  'Technology Education',
  'World Languages']

let resolveIds = (subjects) => {
  let ids = []
  if (subjects) {
    for (let subject of subjects) {
      if (flaggedSubject(subject)) {
        ids = ids.concat(resolveSubjects(subject))
      } else {
        ids.push(subject)
      }
    }
    return ids
  }
}

let resolveSubjects = (subject) => {
  switch (subject) {
    case subjectIds.ARTS_EDUCATION_ID:
      return ['Art and Design', 'Music']
    case subjectIds.CAREER_TECHNICAL_EDUCATION_ID:
      return ['Special Education', 'Other']
    case subjectIds.HEALTH_AND_PE_ID:
      return ['Health and Physical Education']
    case subjectIds.LANGUAGE_ARTS_ID:
      return ['English Language Arts']
    case subjectIds.SOCIAL_STUDIES_ID:
      return ['Social Studies', 'Geography', 'History', 'Citizenship']
    case subjectIds.TECHNOLOGY_EDUCATION_ID:
      return ['ICT']
    case subjectIds.WORLD_LANGUAGES_ID:
      return ['English as a Second Language', 'Foreign Languages', 'Religion']
  }
}

let resolveSubjectIdForUpload = (id) => {
  switch (id) {
    case subjectIds.ARTS_EDUCATION_ID:
      return 'Art and Design'
    case subjectIds.CAREER_TECHNICAL_EDUCATION_ID:
      return 'Special Education'
    case subjectIds.HEALTH_AND_PE_ID:
      return 'Health and Physical Education'
    case subjectIds.LANGUAGE_ARTS_ID:
      return 'English Language Arts'
    case subjectIds.TECHNOLOGY_EDUCATION_ID:
      return 'ICT'
    case subjectIds.WORLD_LANGUAGES_ID:
      return 'English as a Second Language'
    default:
      return id
  }
}

let flaggedSubject = (subject) => {
  return flaggedSubjects.find(s => s === subject)
}

export default {
  resolveIds,
  resolveSubjectIdForUpload
}
